import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.99993 8.94444V5.05556",
      stroke: "#C1C1C1",
      "stroke-width": "1.16667",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.89949 5.43015V4.10051C9.89949 2.49916 8.60135 1.20101 7 1.20101C5.39865 1.20101 4.1005 2.49916 4.1005 4.10051L4.1005 5.43015M9.89949 8.56985V9.89949C9.89949 11.5008 8.60135 12.799 7 12.799C5.39865 12.799 4.1005 11.5008 4.1005 9.89949L4.1005 8.56985",
      stroke: "#C1C1C1",
      "stroke-width": "1.16667",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }